export default __webpack_public_path__ + "static/media/GS.a72696cf.svg";